<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { postReq } from '../../../../services/http';
	import { format } from '../../../../services/i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	//Stores
	import { devices } from 'src/stores/lists/devices';
	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	//Design system components
	import { Button, Input, toast } from '@Shelly/shelly-design-system';
	import SyncName from '../../ApplicationSettings/SyncName.svelte';

	export let device;

	const id = real_id(device.id);

	let settings = readDeviceSettings(id);

	let loading = false;
	let name = settings?.sys?.device?.name ? settings?.sys?.device?.name : device.name;
	let cache = name;
	$: synced = device.name_sync;
	$: error = name === '' && device.name_sync;

	const saveName = async () => {
		name = name.trim();
		if (cache !== name && name !== '') {
			loading = true;
			const params = {
				id: device.channel,
				config: { device: { name } },
			};

			if (synced) {
				const res: SettingRequest = await gen2Request(device, 'Sys.SetConfig', params);
				if (res.isok) {
					cache = name;
					toast.open({
						type: 'success',
						title:
							$format('device_name_scc_toast', { values: { value: name } }) ||
							`Device name changed to ${name}`,
					});
				} else {
					toast.open({ type: 'danger', title: $format('error_global') });
				}
			}

			// if (res.isok) {
			// 	if (synced) {
			device.name = name;
			devices.update(device);
			let int_res = await postReq('interface/device/save', {
				id,
				data: JSON.stringify(device),
			});
			if (int_res.isok) {
				cache = name;
				settings.sys.device.name = name;
				devices_settings.update_devices_settings(id, settings);
				toast.open({
					type: 'success',
					title:
						$format('device_name_scc_toast', { values: { value: name } }) ||
						`Device name changed to ${name}`,
				});
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
			}
			// }

			// } else {
			// 	toast.open({
			// 		type: 'danger',
			// 		title:
			// 			$format('device_name_err_toast') || `Cloud not change device name.`
			// 	});
			// }
			loading = false;
		}
	};
</script>

<Input
	size="m"
	class="mb-s"
	label={$format('sub_settings_title_device_name')}
	bind:value={name}
	on:enter={saveName}
	id="input-r88ut8o"
	aria-labelledby="input-r88ut8o"
/>
<SyncName
	nameType="device"
	{device}
	info={$format('device_rename_description', {
		default:
			'Keep the device name in sync with the name given in the application. The sync is only from the application to the device and not vice-versa.',
	})}
/>
<Button
	class="mt-s"
	{loading}
	size="m"
	width="full"
	on:click={saveName}
	disabled={name.length <= 0 || error}>{$format('button_save')}</Button
>
